import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';


import 'react-toastify/dist/ReactToastify.css';
import './App.css';
//import 'bootstrap/dist/css/bootstrap.min.css';

import { Home } from './pages/Home'
import { List } from './pages/List'
import { Item } from './pages/Item'
import { SitterDetail } from './pages/SitterDetail'
import { Booking } from './pages/Booking'
import { BookingProcessed } from './pages/BookingProcessed'
import { Invoice } from './pages/Invoice'
import { SignIn } from './pages/SignIn'
import { Register } from './pages/Register'
import { Activate } from './pages/Activate'
import { RecoveryPassword } from './pages/RecoveryPassword'
import { PrivateBookings } from './pages/PrivateBookings'
import { PrivateFavorites } from './pages/PrivateFavorites'
import { PrivateMessages } from './pages/PrivateMessages'
import { PrivateProfile } from './pages/PrivateProfile'
import { PrivateReviews } from './pages/PrivateReviews'
import { PrivateWallet } from './pages/PrivateWallet'
import { ChangePassword } from './pages/ChangePassword';
import { TermsConditions } from './pages/TermsConditions';
import { Faq } from './pages/Faq';
import { HowItWorks } from './pages/HowItWorks';
import { PrivacyPolicy } from './pages/PrivacyPolicy';

function App() {
  //console.log(process.env.REACT_APP_CLIENT_ID);
  const [token, setToken] = useState();

  useEffect(() => {
    let kwt = sessionStorage.getItem('kwt');

    if (!!kwt) {
      setToken(kwt)
    }
  }, []);

  return (
    <BrowserRouter>
      <ToastContainer />
      <div id="wrapper">
        <Routes>
          <Route path="/list" element={<List />} />
          <Route path="/item" element={<Item />} />
          <Route path="/sitter" element={<SitterDetail />} />
          <Route path="/booking" element={token ? <Booking /> : <SignIn />} />
          <Route path="/bookingProcessed" element={token ? <BookingProcessed /> : <SignIn />} />
          <Route path="/invoice" element={token ? <Invoice /> : <SignIn />} />
          <Route path="/messages" element={token ? <PrivateMessages /> : <SignIn />} />
          <Route path="/wallet" element={token ? <PrivateWallet /> : <SignIn />} />
          <Route path="/bookings" element={token ? <PrivateBookings /> : <SignIn />} />
          <Route path="/favorites" element={token ? <PrivateFavorites /> : <SignIn />} />
          <Route path="/profile" element={token ? <PrivateProfile /> : <SignIn />} />
          <Route path="/reviews" element={token ? <PrivateReviews /> : <SignIn />} />
          <Route path="/signin" element={token ? <PrivateProfile /> : <SignIn />} />
          <Route path="/register" element={token ? <PrivateProfile /> : <Register />} />
          <Route path="/activate" element={token ? <PrivateProfile /> : <Activate />} />
          <Route path="/changePassword" element={token ? <PrivateProfile /> : <ChangePassword />} />
          <Route path="/recoveryPassword" element={<RecoveryPassword />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/howitworks" element={<HowItWorks />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/" element={<Home />} />
        </Routes>
        <div id="backtotop"><a href="#"></a></div>
      </div>
    </BrowserRouter>
  );
}

export default App;